<ng-container>
    <button [class.text-hidden.text-unhide-hover]="showAsCollapsed"
            class="unassigned-tank-button"
            mat-stroked-button
            color="primary"
            (click)="onClick()">
        <i class="fas fa-unlink"></i>&nbsp;
        <span class="button-text" *ngIf="this.deviceCategory !== this.DeviceTypeCategory.skyTankSensor">{{ 'TankGrid.UnassignTank.Unassign' | translate }}</span>
        <span class="button-text" *ngIf="this.deviceCategory === this.DeviceTypeCategory.skyTankSensor">{{ 'TankGrid.UnassignTank.Disconnect' | translate }}</span>
    </button>

</ng-container>
